"use client";

import { lazy } from "react";

import { handleComponentLoadError } from "@faire/retailer/lib/loadChunkErrors";

// BrandProducts is important but is not currently part of the LCP, and pulls in
// a significant amount of web-retailer and vendor code.
//
// As of July 2022, delaying it does not seem to hurt overall page performance
// since loading the product list takes a fair bit of server time. If we can get
// the product search to be faster/reasonably part of the first paint, we should
// revist making this lazy, and instead try to reduce the amount of code BrandProducts
// needs to pull in for the initial render.
export const LazyBrandProducts = lazy(() =>
  import(
    /* webpackChunkName: "retailer-logged-out-brand-products" */ "./BrandProducts"
  )
    .then((m) => ({ default: m.BrandProducts }))
    .catch(handleComponentLoadError)
);
